import { SetupIntent } from '@stripe/stripe-js';
import { IPaymentCard } from '../../types/global/generic.types';

export const types = {
    ADD_PAYMENT_METHOD: 'ADD_PAYMENT_METHOD',
    ADD_PAYMENT_METHOD_SUCCESS: 'ADD_PAYMENT_METHOD_SUCCESS',
    ADD_PAYMENT_METHOD_FAIL: 'ADD_PAYMENT_METHOD_FAIL',

    UPDATE_PAYMENT_METHOD: 'UPDATE_PAYMENT_METHOD',
    UPDATE_PAYMENT_METHOD_SUCCESS: 'UPDATE_PAYMENT_METHOD_SUCCESS',
    UPDATE_PAYMENT_METHOD_FAIL: 'UPDATE_PAYMENT_METHOD_FAIL',

    DELETE_PAYMENT_METHOD: 'DELETE_PAYMENT_METHOD',
    DELETE_PAYMENT_METHOD_SUCCESS: 'DELETE_PAYMENT_METHOD_SUCCESS',
    DELETE_PAYMENT_METHOD_FAIL: 'DELETE_PAYMENT_METHOD_FAIL',

    GET_PAYMENT_METHODS: 'GET_PAYMENT_METHODS',
    GET_PAYMENT_METHODS_SUCCESS: 'GET_PAYMENT_METHODS_SUCCESS',
    GET_PAYMENT_METHODS_FAIL: 'GET_PAYMENT_METHODS_FAIL',

    CREATE_PAYMENT_INTENT: 'CREATE_PAYMENT_INTENT',
    CREATE_PAYMENT_INTENT_SUCCESS: 'CREATE_PAYMENT_INTENT_SUCCESS',
    CREATE_PAYMENT_INTENT_FAIL: 'CREATE_PAYMENT_INTENT_FAIL',

    CREATE_PAYMENT_INTENT_FOR_PURCHASE: 'CREATE_PAYMENT_INTENT_FOR_PURCHASE',
    CREATE_PAYMENT_INTENT_FOR_PURCHASE_SUCCESS: 'CREATE_PAYMENT_INTENT_FOR_PURCHASE_SUCCESS',
    CREATE_PAYMENT_INTENT_FOR_PURCHASE_FAIL: 'CREATE_PAYMENT_INTENT_FOR_PURCHASE_FAIL',

    GET_PUBLISHABLE_KEY: 'GET_PUBLISHABLE_KEY',
    GET_PUBLISHABLE_KEY_SUCCESS: 'GET_PUBLISHABLE_KEY_SUCCESS',
    GET_PUBLISHABLE_KEY_FAIL: 'GET_PUBLISHABLE_KEY_FAIL',
};

export interface IPaymentInitialState {
    paymentMethods?: IPaymentCard[];
    loading?: boolean;
    errMsg?: any;
    paymentIntentToken?: string;
    publishableKey?: string;
    isNonUs?: boolean;
    error?: any;
}

export type PaymentIntentStatus =
    | 'requires_payment_method'
    | 'requires_confirmation'
    | 'requires_action'
    | 'processing'
    | 'requires_capture'
    | 'canceled'
    | 'succeeded';

export interface PaymentIntentDTO {
    payment_method_types?: string[]; // e.g. ['card', 'wallet]
    latest_charge?: string | null; // charge ID
    capture_method?: 'automatic' | 'manual';
    confirmation_method?: 'automatic' | 'manual';
    next_action?: {
        type:
            | 'use_stripe_sdk'
            | 'redirect_to_url'
            | 'verify_with_microdeposits'
            | 'display_bank_transfer_instructions'
            | string;
        redirect_to_url?: {
            url: string;
            return_url?: string | null;
        } | null;
        use_stripe_sdk?: unknown;
        // add more fields you actually consume
    } | null;
    automatic_payment_methods?: {
        enabled?: boolean;
    };
}

export interface ICreatePaymentIntent {
    /** card */
    payment_method_type?: string;
    /**usd aud */
    currency?: string;
    /** amount in smallest unit */
    amount?: number;
    save_card?: boolean;
    metadata?: string;
    stripe_payload?: PaymentIntentDTO;
}

export interface IPaymentIntentResponse {
    clientSecret: string;
}

export interface IGetStripePublicKey {}

export interface IAddNewCard {
    payment_method: string;
    fullName: string;
    intent: SetupIntent;
}

export interface IGetPublishableKey {
    source: 'stripe' | 'paystack';
}

export interface IGetPublishableKeyResponse {
    publishableKey: string;
    /** Returns whether the current user is within AFrica, to use Psyatck */
    isNonUs: boolean;
}
